import { boolean, defineAction, object, string } from '~/prix'
import systemUserAuthEventLogAction from './systemUserAuthEventLog.action.json'

const systemUserAuthEventLogDefinition = defineAction({
  ...systemUserAuthEventLogAction,
  input: object({
    event: string(),
  }),
  output: object({
    ok: boolean(),
  }),
})

export default systemUserAuthEventLogDefinition
